module.exports = __webpack_public_path__ + "media/images/avatar/10-2a685e03af53830f4a6af96ba0d9f9c9.jpg";